import getClient from './getClient'

interface SignUpProps {
  email: string
  metadata?: object
}

export default function signUp({ email, metadata }: SignUpProps) {
  return getClient().auth.signInWithOtp({
    email,
    options: {
      data: metadata,
    },
  })
}
